// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import HelloController from "./hello_controller"
application.register("hello", HelloController)

import CopyController from "./copy_controller"
application.register("copy", CopyController)

import CharacterCounterController from "./character_counter_controller"
application.register("character-counter", CharacterCounterController)

import RecipientSlotsController from "./recipient_slots_controller"
application.register("recipient-slots", RecipientSlotsController)

import FlashController from "./flash_controller"
application.register("flash", FlashController)

import PostShareController from "./post_share_controller"
application.register("post-share", PostShareController)

import PhoneInputController from "./phone_input_controller"
application.register("phone-input", PhoneInputController)

import ModalController from "./modal_controller"
application.register("modal", ModalController)

import SmartShareController from "./smart_share_controller"
application.register("smart-share", SmartShareController)

import OtpController from "./otp_controller"
application.register("otp", OtpController)

import ReplyChoiceController from "./reply_choice_controller"
application.register("reply-choice", ReplyChoiceController)

import HeroBackgroundController from "./hero_background_controller"
application.register("hero-background", HeroBackgroundController)

import AnalyticsController from "./analytics_controller"
application.register("analytics", AnalyticsController)
